import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `CambioEstadoVerraco/getFiltrarCambioEstadoVerraco`, method: 'POST', body: values, token: token})
}
